import { getLocale, translate } from "./index";

// Authentication services return English prose; prefer stable exception identifiers.
export function formatAuthError(error, fallback = translate("An unexpected error occurred.")) {
  switch (error?.name || error?.code) {
    case "NotAuthorizedException":
    case "UserNotFoundException":
      return translate("The email or password is incorrect.");
    case "CodeMismatchException":
    case "ExpiredCodeException":
      return translate("That code is invalid or expired. Please request a new code.");
    case "InvalidPasswordException":
      return translate("Please check the password requirements and try again.");
    case "LimitExceededException":
    case "TooManyRequestsException":
      return translate("Too many attempts. Please wait a few minutes and try again.");
    case "UserNotConfirmedException":
      return translate("Please confirm your email before signing in.");
    case "NetworkError":
      return translate("Check your internet connection and try again.");
    default:
      return getLocale() === "en" ? error?.response?.data?.message || error?.message || fallback : fallback;
  }
}
